import React, { useCallback, useEffect } from "react";
import Components from "./components";
import Sidebar from "./components/Sidebar/Sidebar";
import AdminNavbar from "./components/Navbars/AdminNavbar";
import Footer from "./components/Footer/Footer";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import { getRootByRole } from "./Redux/rootBaseReduce";
import { verification } from "./Redux/usersReduce";
import { useDispatch, useSelector } from "react-redux";

function RootBase({ client, view }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { users } = useSelector((state) => state.users);
  const [entities, setEntities] = React.useState([]);

  // Get the client part from the URL (first segment after /)

  const getRoutes = (routes, client) => {

    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views, client);
      }
      if (
        prop.role.includes(users[0].data.user.id_role) ||
        prop.role.includes(20)
      ) {
        const fullPath = `${prop.path}`; // prepend client to path const fullPath = `/${client}${prop.path}`;

        const component = React.createElement(
          Components[prop.componentStr],
          { obj: users[0].data, client: client ? "/" + client : "" },
          null
        );

        return <Route path={fullPath} key={key} render={() => component} />;
      }
      return null;
    });
  };

  const getUser = useCallback(
    async (user, client) => {
      if (user) {
        const root = await dispatch(getRootByRole({ role: user[0].data.user.id_role, client, id_site: user[0].data.id_site, view }));

        const resRoot = await root.payload; console.log(resRoot)
        setEntities(resRoot);
        setLoading(false)
      }
    },
    [dispatch]
  );

  const verifToken = useCallback(
    async (data, client) => {
      try {
        const response = await dispatch(verification());
        if (response.payload === false || response.payload.logout === true) {
          localStorage.clear();
          window.location.replace("/login");
          setLoading(false)
        } else {

          getUser(data, client);

        }
      } catch (error) {
        localStorage.clear();
        window.location.replace("/login");
        setLoading(false)
      }
    },
    [dispatch, getUser]
  );

  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    if (users) verifToken(users, client);
  }, [users, verifToken]);

  if (loading) {
    return <div class="loader-container">
      <div class="loader"></div>
    </div>;
  }



  return (
    <>
      {users && entities.length > 0 ? (
        <div className={"wrapper " + client}>
          <Sidebar users={users[0].data} routes={entities} client={client} />
          <div className="main-panel">
            <AdminNavbar users={users[0].data} client={client} />
            <div className="content">
              <Switch>
                {entities.length > 0 ? getRoutes(entities, client) : ""}
                <Redirect to={`/${client}/mesActualite`} />
              </Switch>
            </div>
            <Footer />
            <div
              className="close-layer"
              onClick={() =>
                document.documentElement.classList.toggle("nav-open")
              }
            />
          </div>
        </div>
      ) : (
        null
      )}
    </>
  );
}

export default RootBase;
